import { c as _c } from "react/compiler-runtime";
import { Download } from 'lucide-react';
import { Trans } from 'react-i18next';
import { MainLayout } from '../../MainLayout';
import { PageHeading } from '../../layout/PageHeading';
import { DesignStepsBar } from '@/components/design/steps/DesignStepsBar';
import { PrintButton } from '../../layout/PrintButton';
import { useAnalyzedKeyboard } from '../../../hooks/keyboard/use-analyzed-keyboard';
import { useDesignedKeyboard } from '../../../hooks/keyboard/use-designed-keyboard';
import { useExportBackupFile } from '@/hooks/backup/use-export-backup-file';
import { useTranslation } from '@/hooks/use-translation';
import { AdjustmentSheet } from '@/components/design/adjustment-sheet/AdjustmentSheet';
import { Button } from '@/components/ui/button';
export const DesignAdjustmentSheetPage = () => {
  const $ = _c(28);
  const analyzedKeyboard = useAnalyzedKeyboard();
  const designedKeyboard = useDesignedKeyboard();
  const {
    exportBackupFile
  } = useExportBackupFile();
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DesignStepsBar currentStepId="sheet" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <em className="ptl-accent">Sheet</em>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== t) {
    t2 = <Trans t={t} i18nKey="Adjustment <1>Sheet</1>">Adjustment {t1}</Trans>;
    t3 = t("Every adjustment at hand in your workshop, key by key.");
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Download className="size-4" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("Export the profile");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== exportBackupFile || $[9] !== t5) {
    t6 = <Button variant="outlineStrong" onClick={exportBackupFile}>{t4}{t5}</Button>;
    $[8] = exportBackupFile;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("Print the sheet");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <PrintButton label={t7} size="default" variant="default" />;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t9) {
    t10 = <PageHeading className="print:hidden" title={t2} lede={t3} ledeWidth="60ch" actions={t9} />;
    $[18] = t2;
    $[19] = t3;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== analyzedKeyboard || $[23] !== designedKeyboard) {
    t11 = <AdjustmentSheet analyzedKeyboard={analyzedKeyboard} designedKeyboard={designedKeyboard} />;
    $[22] = analyzedKeyboard;
    $[23] = designedKeyboard;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <MainLayout>{t0}{t10}{t11}</MainLayout>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};